import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Reactive Graphics", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "Demo de la librería gráfica basada en RxJS.", -1)
const _hoisted_3 = { ref: "canvas" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Layer = _resolveComponent("Layer")
  const _component_LayerOverlay = _resolveComponent("LayerOverlay")

  return (_openBlock(), _createBlock(_component_LayerOverlay, { fullscreen: _ctx.fullcanvas }, {
    default: _withCtx(() => [
      _createVNode(_component_Layer, { zIndex: 1 }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode("canvas", _hoisted_3, null, 512)
    ]),
    _: 1
  }, 8, ["fullscreen"]))
}